// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"ff8ee9d3","935":"587ab0c2"}[chunkId] + ".chunk.js";
};